import { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import useAuth from "./useAuth";
import { ADMINS_COLLECTION_NAME, ADMINS_DOCUMENT_ID, AdminsDocument } from "../@types/sharedSchema";
import { GenericConverter } from "../utils/firestoreConverters";

export default function useWebotAdmin() {
  const { user } = useAuth();
  const [isWebotAdmin, setIsWebotAdmin] = useState(false);
  const [isLoadingAdminStatus, setIsLoadingAdminStatus] = useState(true);
  const [adminEmails, setAdminEmails] = useState<string[]>([]);

  useEffect(() => {
    if (!user?.email) {
      setIsWebotAdmin(false);
      setIsLoadingAdminStatus(false);
      return;
    }

    const adminDocRef = db
      .doc(`${ADMINS_COLLECTION_NAME}/${ADMINS_DOCUMENT_ID}`)
      .withConverter(GenericConverter<AdminsDocument>());

    const unsubscribe = adminDocRef.onSnapshot(
      (snapshot) => {
        const adminDoc = snapshot.data();
        const emails = adminDoc?.adminEmails || [];

        setAdminEmails(emails);
        setIsWebotAdmin(emails.includes(user.email));
        setIsLoadingAdminStatus(false);
      },
      (error) => {
        console.error("Error fetching admin document:", error);
        setIsWebotAdmin(false);
        setIsLoadingAdminStatus(false);
      }
    );

    return () => unsubscribe();
  }, [user?.email]);

  return {
    isWebotAdmin,
    isLoadingAdminStatus,
    adminEmails
  };
}
